import client from '@/base-http'
import Axios, { AxiosResponse, AxiosError, AxiosInstance } from 'axios'
import JWTToken from '../types';

function buildClearClient (): AxiosInstance {
    return Axios.create({
        baseURL: client.defaults.baseURL,
        headers: client.defaults.headers,
    })
}

/**
 * Token
 *
 * Solicita al servidor un nuevo token jwt de autorización para el usuario
 * argumentado.
 *
 * @param user
 * @param password
 */
export const token = async (user: string, password: string): Promise<string> => {

    // Se crea una copia del client http sin el interceptor de autenticación
    const authClient = buildClearClient()

    const response = await authClient.post('token', { user, password })

    return response.data.token
}

/**
 * Añade un token a la lista de negra
 *
 * @param token { JWTToken }
 */
export const addTokenToBlacklist = async (token: JWTToken): Promise<boolean> => {
    const authClient = buildClearClient()

    const response = await authClient.post('token/blacklist/entry', {
        token: token.encoded,
    })

    return response.data.success || false
}
